import { num2, pct } from "@caint/engine";

export interface GaugeProps {
  value: number | null;
  size?: number;
  meta?: number;
  label?: string;
}

function corDoSelo(v: number | null): string {
  if (v == null) {
    return "var(--slate-300)";
  }
  if (v >= 0.85) {
    return "var(--seal-ouro)";
  }
  if (v >= 0.6) {
    return "var(--seal-prata)";
  }
  if (v >= 0.46) {
    return "var(--seal-bronze)";
  }
  return "var(--seal-dev)";
}

/** Anel radial colorido pela faixa de selo, com o IMGQ no centro. */
export function Gauge({ value, size = 116, meta = 0.46, label }: GaugeProps) {
  const v = value ?? 0;
  const r = (size - 14) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - v);
  const meio = size / 2;
  return (
    <div className="m-gauge" style={{ width: size, height: size }}>
      <svg width={size} height={size} aria-hidden="true">
        <circle cx={meio} cy={meio} r={r} fill="none" stroke="var(--surface-2)" strokeWidth="8" />
        <circle
          cx={meio}
          cy={meio}
          r={r}
          fill="none"
          stroke={corDoSelo(value)}
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={off}
          transform={`rotate(-90 ${meio} ${meio})`}
          style={{ transition: "stroke-dashoffset .5s var(--ease)" }}
        />
      </svg>
      <div className="gv">
        <b>{pct(value)}</b>
        <span>{label ?? `meta ${num2(meta)}`}</span>
      </div>
    </div>
  );
}

export interface MeterProps {
  value: number | null;
}

/** Barra de faixas do IMGQ com os limiares 46/60/85 e marcador. */
export function Meter({ value }: MeterProps) {
  const left = value == null ? 0 : Math.max(0, Math.min(100, value * 100));
  return (
    <div style={{ position: "relative" }}>
      <div className="m-meter">
        <div
          className="seg"
          style={{ width: "46%", background: "color-mix(in srgb, var(--seal-dev) 28%, white)" }}
        />
        <div
          className="seg"
          style={{ width: "14%", background: "color-mix(in srgb, var(--seal-bronze) 45%, white)" }}
        />
        <div
          className="seg"
          style={{ width: "25%", background: "color-mix(in srgb, var(--seal-prata) 50%, white)" }}
        />
        <div
          className="seg"
          style={{ width: "15%", background: "color-mix(in srgb, var(--seal-ouro) 55%, white)" }}
        />
      </div>
      {value != null && <div className="m-meter-mark" style={{ left: `${left}%` }} />}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 6,
          fontFamily: "var(--font-mono)",
          fontSize: 9.5,
          color: "var(--text-faint)",
        }}
      >
        <span>0</span>
        <span>46</span>
        <span>60</span>
        <span>85</span>
        <span>100</span>
      </div>
    </div>
  );
}
